if (!customElements.get("page-header-image-banner")) {
  customElements.define(
    "page-header-image-banner",
    class ImageBanner extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest("section") || this.closest("header");
        this.logoBanner = this;
        this.header = document.querySelector(".wt-header");
        this.isMobile = window.matchMedia("(max-width: 899px)").matches;
        this.logoWrapper = this.header.querySelector(".wt-header__logo");
        this.showLogoClass = "wt-header__logo--show";
      }

      connectedCallback() {
        this.init();
        document.addEventListener("shopify:section:load", this.handleAdminEditing.bind(this));
        document.addEventListener("shopify:section:unload", this.handleAdminEditing.bind(this));
        document.addEventListener("shopify:section:reorder", this.handleAdminEditing.bind(this));
      }

      handleAdminEditing() {
        this.init();
      }

      init() {
        const logoWrapper = document.querySelector(".wt-header__logo");
        if (this.isTransparentHeaderEnabled()) {
          this.setTopMargin();
          this.observeHeader();
          logoWrapper?.classList.add(this.showLogoClass);
        } else {
          this.resetTopMargin();
          logoWrapper?.classList.remove(this.showLogoClass);
        }
      }

      removeObserver() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }

      resetTopMargin() {
        if (this.section) this.section.style.marginTop = "0";
      }

      disconnectedCallback() {
        this.logoWrapper?.classList.remove(this.showLogoClass);
        this.removeObserver();
        if (this.scrollListener) {
          document.removeEventListener("scroll", this.scrollListener);
          this.scrollListener = null;
        }
        document.removeEventListener("shopify:section:load", this.handleAdminEditing.bind(this));
        document.removeEventListener("shopify:section:unload", this.handleAdminEditing.bind(this));
        document.removeEventListener("shopify:section:reorder", this.handleAdminEditing.bind(this));
      }

      observeHeader() {
        const header = document.querySelector(".wt-header");
        const activeTransparentClass = "wt-header--transparent";
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                header.classList.remove(activeTransparentClass);
              } else {
                header.classList.add(activeTransparentClass);
              }
            });
          },
          { root: null, threshold: 0.05 }
        );
        this.observer.observe(this.logoBanner);
      }

      isValidSectionsOrder() {
        const header = document.querySelector(".wt-header");
        if (!header) return false;

        // Check if this element is inside the header group
        if (header.contains(this)) return true;

        // Fallback: check if first section after header
        const pageHeader = document.body.querySelector("header.page-header");
        const currentSection = this.section;
        if (pageHeader && currentSection) {
          let sibling = pageHeader.nextElementSibling;
          while (sibling) {
            if (sibling.tagName.toLowerCase() === "section") {
              return sibling === currentSection || sibling.contains(this);
            }
            sibling = sibling.nextElementSibling;
          }
        }
        return false;
      }

      isTransparentHeaderEnabled() {
        const header = document.querySelector(".wt-header");
        return this.isValidSectionsOrder() && Boolean(header?.dataset.transparent);
      }

      calculateOffset() {
        const header = document.querySelector("header");
        const headerHeight = header ? header.offsetHeight : 0;
        const announcement = document.querySelector(".wt-announcement");
        const announcementHeight = announcement ? announcement.offsetHeight : 0;
        return this.isTransparentHeaderEnabled() ? headerHeight + announcementHeight : 0;
      }

      setTopMargin() {
        const offset = this.calculateOffset();
        if (this.section) this.section.style.marginTop = `-${offset}px`;
      }
    }
  );
}